import { LoadingOutlined } from '@ant-design/icons';
import { useMount } from 'ahooks';
import { message } from 'antd';
import { useNonPlatformQaEnable } from 'hooks/business/useOrgConfig';
import useCrud from 'hooks/useCrud';
import { noop } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import NightWatch from 'views/Aide/Qa/NightWatch/NightWatch';
import Policy from 'views/Aide/Qa/NightWatch/Policy';
import { config, init } from 'views/Aide/Qa/NightWatch/service';

export interface NightWatchPolicyProps {
  platform?: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  storeGroupId: string | number;
  policyId?: number;
  editable?: boolean;
  onClose?: (e?: any) => void;
}

function NightWatchPolicy(props: NightWatchPolicyProps) {
  const { platform: platformProp, region, storeGroupId, policyId, editable, onClose } = props;

  const { t } = useTranslate();

  const nonPlatformQaEnable = useNonPlatformQaEnable();

  const platform = nonPlatformQaEnable ? undefined : platformProp;

  const { loading, item, fetch } = useCrud({
    read: config,
  });

  useMount(() => {
    init(storeGroupId).then(() =>
      fetch({
        groupId: storeGroupId,
        needPolicy: true,
      }).catch(() => {
        message.error(t('phrase.获取数据失败，请稍后再试'));
      }),
    );
  });

  if (!item) {
    return loading ? <LoadingOutlined /> : null;
  }

  const { policy: policyList } = item;

  // eslint-disable-next-line eqeqeq
  const policy = policyList.find((_) => (policyId ? _.fallbackPolicyId == policyId : _.isTransfer));

  if (policy) {
    return (
      <Policy
        initialValue={[item, policy]}
        platform={platform}
        region={region}
        storeGroupId={storeGroupId}
        policyId={policy.fallbackPolicyId}
        editable={editable}
        onClose={onClose || noop}
      />
    );
  }

  return (
    <NightWatch
      initialValue={item}
      platform={platform}
      region={region}
      storeGroupId={storeGroupId}
      editable={editable}
    />
  );
}

export default NightWatchPolicy;
